import QuizRereviewBanner from "@/components/banners/quiz-rereview-banner";
import EmptyState from "@/components/empty-state";
import PageHeader from "@/components/page-header";
import { Button } from "@/components/ui/button";
import { Skeleton } from "@/components/ui/skeleton";
import { useCanViewResults } from "@/hooks/can-view-results.hook";
import { useCurrentUserProfile } from "@/hooks/current-user-profile.hook";
import { useQuizById } from "@/hooks/quiz-by-id.hook";
import { currentEditionIdAtom } from "@/store/edition-id.store";
import { useAtomValue } from "jotai";
import { Link, Outlet, useParams, useSearchParams } from "react-router-dom";
import HeaderActions from "./header-actions";
import Navbar from "./navbar/navbar";
import ResultsPageBreadcrumbs from "./results-page-breadcrumbs";

const ResultsPage = () => {
  const [searchParams] = useSearchParams();

  const ref = searchParams.get("ref");

  const { quizId } = useParams();

  const editionId = useAtomValue(currentEditionIdAtom);

  const { data: userProfile } = useCurrentUserProfile();

  const { data: quiz, isLoading: isCurrentQuizLoading } = useQuizById({
    companyId: userProfile?.companyId || "",
    applicationQuizId: quizId || "",
  });

  const editionName = quiz?.edition.name || "";

  const canViewResults = useCanViewResults(editionId);

  return (
    <div className="flex flex-col gap-6">
      <ResultsPageBreadcrumbs
        forPreviousEditions={ref === "previous-editions"}
        editionName={editionName}
      />

      <PageHeader className="mb-4" title="Reporte de resultados">
        <HeaderActions />
      </PageHeader>

      {isCurrentQuizLoading ? (
        <div className="flex flex-col gap-4">
          <Skeleton className="bg-gray-200" style={{ height: "180px" }} />
          <Skeleton className="bg-gray-200" style={{ height: "180px" }} />
        </div>
      ) : canViewResults ? (
        <>
          <QuizRereviewBanner />

          <Navbar />

          <Outlet />
        </>
      ) : (
        <div className="mx-auto my-8">
          <EmptyState message="No tienes resultados disponibles">
            <Button variant={"secondary"} className="mt-4" asChild>
              <Link to="/">Volver a la página principal</Link>
            </Button>
          </EmptyState>
        </div>
      )}
    </div>
  );
};

export default ResultsPage;
